var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-center"},[_c('i',{staticClass:"fas fa-male fa-sm",class:{ selected: _vm.isGender('Mann') }}),_vm._v(" "),_c('i',{staticClass:"fas fa-female fa-sm",class:{ selected: _vm.isGender('Frau') }})])
}
var staticRenderFns = []

export { render, staticRenderFns }